<template>
    <div class="col-12 col-sm-12 col-md-12 col-lg-10">
        <div class="featured-box home-page-man">
            <div class="mobile-nav-bg">
                <ul class="nav nav-tabs mobile-tabs" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation" v-for="(sport, sIndex) in sortedSportsList" :key="sIndex">
                        <button class="nav-link" :class="{active: activeTab == sport.slug }" :id="'all-tab' + sport.id" data-bs-toggle="tab" data-bs-target="#Football" type="button" role="tab"
                            @click="activeTab != sport.slug ? getSportsListService(sport) : ''">
                        <div class="nav-img">
                            <img :src="getSportImage(sport.id)" alt="" loading="lazy">
                        </div>
                        {{ sport.name }}
                        </button>
                    </li>
                </ul>
            </div>

            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade active show" id="Football" role="tabpanel" aria-labelledby="Football-tab">
                    <div class="mobile-game-live ">
                        <ul class="live_virtual">
                            <li><input type="checkbox" value="Order one" class="filter-checkbox" @change="toggleFilter('live')"><label>{{$t('live','LIVE')}}</label></li>
                            <li><input type="checkbox" value="Order Two" class="filter-checkbox" @change="toggleFilter('virtual')"><label>{{$t('virtual','VIRTUAL')}}</label></li>
                        </ul>
                        <div class="filter-ct"><label>{{$t('view-by', 'View by')}}:</label>
                            <select class="form-control-sm" v-model="displayType">
                                <option value="competition">{{$t('competitions', 'Competitions')}}</option>
                                <option value="time">{{$t('time', 'Time')}}</option>
                            </select>
                        </div>                          
                        <div class="game-listing-container" v-if="sortedMatchList?.length">  
                            <MobileSportItem :sportItemDetail="sortedMatchList" :displayType="displayType"></MobileSportItem>                    
                        </div>
                        <div class="norecords" v-if="sortedMatchList?.length==0 && loading==false">
                            {{$t('no-real-records', 'No Real-Time Records Found')}}
                        </div>
                    </div>

                    <div class="mobile-game-live" v-if="inplayMatches[activeTab]?.matches?.length">
                        <div class="filter-ct" v-if="inplayMatches[activeTab]?.matches?.length">
                            <ul class="live_virtual">
                                <li><input type="checkbox" value="Order one" class="filter-checkbox" @change="changeFilterKey('live', inplayMatches[activeTab]?.filterKey)"><label>{{$t('live','LIVE')}}</label></li>
                                <li><input type="checkbox" value="Order Two" class="filter-checkbox" @change="changeFilterKey('virtual',inplayMatches[activeTab]?.filterKey)"><label>{{$t('virtual','VIRTUAL')}}</label></li>
                            </ul>
                            <label>{{$t('view-by', 'View by')}}:</label>
                            <select class="form-control-sm" v-model="displayType">
                                <option value="competition">{{$t('competitions', 'Competitions')}}</option>
                                <option value="time">{{$t('time', 'Time')}}</option>
                            </select>
                        </div>
                        <div class="game-listing-container" v-if="inplayMatches[activeTab]?.matches?.length">                   
                            <MobileSportItem :sportItemDetail="filterMatches(inplayMatches[activeTab])" :displayType="displayType"></MobileSportItem>                       
                        </div>
                        <div class="norecords" v-if="inplayMatches[activeTab]?.matches?.length == 0">
                            {{$t('no-real-records', 'No Real-Time Records Found')}}
                        </div>
                    </div>

                    <section class="bet-details-sec">
                        <div class="game-live">
                            <div class="tabs-menu-head">
                                <div class="row">
                                    <div class="col-md-8"><span class="game-mode">{{$t('match', 'Match')}}</span></div>
                                    <div class="col-md-4">
                                        <div class="oddsEventlist">
                                            <div class="btn-group"><span>1</span></div>
                                            <div class="btn-group"><span>X</span></div>
                                            <div class="btn-group"><span>2</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <SportItem :sportItemDetail="sortedMatchList"></SportItem>
                        </div>
                    </section>

                </div>

            </div>
            
            <section class="produact-item">
                <!-- <span class="our-casino">{{$t('our-casino', 'Our Casino')}}</span> -->
                <div class="static-home-games">
                    <div class="game-card2" v-for="(item, gItemKey) in staticGames" :key="gItemKey">
                        <a href="Javascript:void(0);" @click="goToGames(item)">
                            <div class="casinoicons casino-list-item-img">
                                <img alt="" :src="item.imgSrc" class="img-fluid" />
                            </div>
                        </a>
                    </div>
                </div>
                <ul class="nav casino-tab-wrap" id="myTab" role="tablist" v-if="homeSectionMenus?.menus && homeSectionMenus?.menus?.length > 0">                    
                    <li class="nav-item" role="presentation" v-for="(menu, mIndex) in homeSectionMenus.menus" :key="mIndex">
                        <button class="nav-link" :class="{'active' : menu.slug == menuGameList.slug}" id="providers" @click="menuGameList = menu">
                            {{ menu.title }}
                        </button>
                    </li>
                </ul>
                <div class="prouduts" v-if="menuGameList && menuGameList.games && menuGameList.games.length > 0">
                    <GameItem :games="menuGameList.games"></GameItem>
                    </div>
                    <!-- <div class="norecords" v-else>
                    {{$t('no-real-records', 'No Real-Time Records Found')}}
                    </div> -->
            </section>

        </div>

    </div>
    <!-- User journay Info -->  
    <div class="col-12 col-sm-12 col-md-12">
    <div class="user-jounery-info-bx" v-if="tutorials.length">    
        <div class="cmn-head-3"><h3>User Journey Info</h3></div>
        <div class="row">
            <div class="col-6 col-sm-4 col-md-3" v-for="(tut, idx) in tutorials" :key="tut.videoKey">
            <div class="support-btn-con">
                <button type="button" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#faqVideoModal"  @click="playVideo(tut.videoKey, tut.imageKey, tut.title)">{{ idx + 1 }}. {{ tut.title }} </button>
            </div>
            </div>
        </div>
    </div>
    </div>
    <div class="modal fade modal-style" id="faqVideoModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">

                <div class="modal-header">
                    <h5 class="modal-title">{{videoTitle}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <video controls :poster="videoThumbnail" :src="videoUrl" class="video-display"></video>
                </div>
            </div>
        </div>
    </div>
    <div class="v-social-icon" v-if="$siteSettings?.data">
        <ul>
            <li v-if="$siteSettings?.data?.apk">
                <a :href="$siteSettings?.data?.aws_url + $siteSettings?.data?.storage_path?.apk_path + $siteSettings?.data?.apk" :download="$siteSettings?.data?.apk">
                    <img src="@/assets/images/download-apk.svg" alt="">
                </a>
            </li>
            <li v-else>
                <a type="button" href="#install-apk-model" data-bs-toggle="modal">
                    <img src="@/assets/images/download-apk.svg" alt="">
                </a>
            </li>

            <li v-if="$siteSettings?.data?.business_type == 2 && $siteSettings?.data?.social_link?.telegram_link">
                <a :href="$siteSettings?.data.social_link?.telegram_link" target="_blank">
                    <img class="social_icon_cl" src="@/assets/images/telegram.svg" alt="">
                </a>
            </li>

            <li v-if="$siteSettings?.data?.business_type == 2 && $siteSettings?.data?.social_link?.whatsappno1">
                <a :href="'//wa.me/'+$siteSettings?.data.social_link?.whatsappno1" target="_blank">
                    <img class="social_icon_cl" src="@/assets/images/whatsapp-share.svg" alt="">
                </a>
            </li>

            <li v-if="$siteSettings?.data?.business_type == 2 && $siteSettings?.data?.social_link?.instagram_link">
                <a :href="$siteSettings?.data.social_link?.instagram_link" target="_blank">
                    <img class="social_icon_cl" src="@/assets/images/instagram.svg" alt="">
                </a>
            </li>
           
            
        </ul>
    </div>

    <!-- Back to top button -->
    <div class="scroll-move-to-top-btn">
        <div class="contentDiv" id="content">
            <button class="back-to-top" :class="{show: scrollHeight}" type="button" @click="scrollToTop()"></button>
        </div>
    </div>

    <DownloadApkModal></DownloadApkModal>
</template>

<script>

import { defineAsyncComponent } from 'vue';
import * as varConstants from '@/shared/constants/var-constants';
import { checkForLockedMatches, checkEventManageforSports, checkInEventMangeForSection } from '@/shared/services/eventLocks.js';
import { mapGetters } from 'vuex';


export default {
    name: "HomePage",
    components: {
        SportItem: defineAsyncComponent(() =>
            import('@/modules/sports/components/SportItem.vue')
        ),
        Race: defineAsyncComponent(() =>
            import('@/shared/components/race/Race.vue')
        ),
        MobileSportItem: defineAsyncComponent(() =>
            import('@/modules/sports/components/MobileSportItem.vue')
        ),
        GameItem: defineAsyncComponent(() =>
            import('@/shared/components/games/GameItem.vue')
        ),
        DownloadApkModal: defineAsyncComponent(() =>
            import('@/shared/components/modal/DownloadApkModal.vue')
        )
    },
    data() {
        return {
            matches_list: [],
            matchesArray: [],
            leagueList: [],
            selectedLeague: [],
            favouriteList: JSON.parse(localStorage.getItem(varConstants.FAV_SPORTS_LIST)),
            marketOdds: {},
            inplayMatches: {},
            inplayMarketOdds: {},
            sportsList: [],
            marketOdds: {},
            matchesArray: {},
            clickApiUrl: process.env.VUE_APP_CLICK_API + 'v1/aws-s3/download/',
            favouriteList: JSON.parse(localStorage.getItem(varConstants.FAV_SPORTS_LIST)),
            favouriteSportsList: localStorage.getItem(varConstants.FAV_SPORTS_LIST) ? JSON.parse(localStorage.getItem(varConstants.FAV_SPORTS_LIST)) : [],
            activeTab: 'cricket',
            gamesData: null,
            scrollHeight: window.scrollY,
            bodyloadmodal: null,
            displayType: 'time',
            sectionsList:null,
            whatsappNumbers:[],
            staticGames: [
                {
                    game_name: 'Aviator',
                    slug: 'aviator',
                    catSlug: 'static-games',
                    imgSrc: require('@/assets/images/aviator.gif')
                },
                {
                    game_name: 'Mines',
                    slug: 'mines',
                    catSlug: 'static-games',
                    imgSrc: require('@/assets/images/mines.gif')
                },
                {
                    game_name: 'Fun Games',
                    slug: 'fun-games',
                    catSlug: 'static-games',
                    imgSrc: require('@/assets/images/fungames.gif')
                },
                {
                    game_name: 'Color Pridiction',
                    slug: 'colour-game',
                    catSlug: 'static-games',
                    imgSrc: require('@/assets/images/color-pridiction.gif')
                }
            ],
            homeSectionMenus: null,
            menuGameList: null,
            selectedFilters: [],
            videoUrl: null,
            videoTitle: null,
            videoThumbnail: null
        };
    },
    computed: {
        ...mapGetters(['sports_list']),
        sport_id() {
            return this.$route.params.id
        },
        sport_type() {
            return this.$route.params.type ?? null
        },
        sortedMatchList() {
            return this.displayType === 'competition' ? this.filteredLeagueList : this.filteredMatchList;
        },
        filteredMatchList() {
            if (this.selectedFilters.includes('live') && this.selectedFilters.includes('virtual')) {
                return this.matches_list || [];
            }

            if (this.selectedFilters.includes('live')) {
                const temporaryData = (this.matches_list || []).filter(match => match.is_exclusive === 0);
                return temporaryData;
            }

            if (this.selectedFilters.includes('virtual')) {
                return (this.matches_list || []).filter(match => match.is_exclusive === 1);
            }

            return this.matches_list || [];
        },

        filteredLeagueList() {
            if (!this.selectedFilters.includes('live') && !this.selectedFilters.includes('virtual')) {
                return this.leagueList || [];
            }

            return (this.leagueList || []).filter(match =>
                (this.selectedFilters.includes('live') && match.is_exclusive === 0) ||
                (this.selectedFilters.includes('virtual') && match.is_exclusive === 1)
            );
        },
        sortedSportsList() {
            if(this.sports_list) {
                const topNonCustom = this.sports_list?.non_custom?.filter(sport => 
                    ['cricket', 'soccer', 'tennis'].includes(sport.slug)
                );
                const remainingNonCustom = this.sports_list?.non_custom?.filter(sport => 
                    !['cricket', 'soccer', 'tennis'].includes(sport.slug)
                );
                return [...topNonCustom,...this.sports_list?.custom, ...remainingNonCustom];
            };
            return [];
        },
        tutorials() {
            const journey = this.$siteSettings?.data?.user_journey ?? {};

            const allTutorials = [
                { title: "How to Login",            videoKey: "login_video",        imageKey: "login_img"      },
                { title: "How to Register",         videoKey: "register_video",     imageKey: "register_img"   },
                { title: "Introduction",            videoKey: "introduction_video", imageKey: null             },
                { title: "How to Withdraw",         videoKey: "withdrawal_video",   imageKey: null             },
                { title: "How to Play",             videoKey: "play_video",         imageKey: "play_img"       },
                { title: "How to Play Bonus",       videoKey: "use_bonus_video",    imageKey: null             },
                { title: "How to Deposit English",  videoKey: "deposit_video_e",    imageKey: null             },
                { title: "How to Deposit Hindi",    videoKey: "deposit_video_h",    imageKey: null             },
            ];

            return allTutorials.filter(t => Boolean(journey[t.videoKey]));
        }
    },
    mounted() {
        this.sportsList = this.$store.getters.sports_list; 
        let headRoute = this.$route.params
        if(headRoute.head_sport) { //coming directly from header
            let headSport = this.sportsList?.custom?.find(item => item.id == headRoute.id)
            this.getSportsList(headSport);
            this.activeTab = headSport.slug;
        } else {
            let initSportId = this.sportsList?.non_custom?.find(item => item.slug == 'cricket');
            this.getSportsList(initSportId);
        }
        this.getCasinoGamesServiceCall();
        window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
        getSportsList(sport = false) {
            this.loading = true;
            let sportID = sport.id || '4';
            if(!sportID)
                {
                    this.$errorToast("Sport Id Not Available");
                    return;
                }
            this.$apiCall('get', 'MATCHES_BY_SPORT_ID', null, 'sports', { sport_id: sportID }).then(response => {
                this.loading = false;
                if (response) {
                    if (response.status == 200) {
                        sport && (this.activeTab = sport.slug);
                        this.matches_list = response.data.data;
                        for (let match of this.matches_list) {
                            this.marketOdds[match.market_id] = match.runners??[];
                        }
                        this.matchesArray = response.data.data;
                        this.leagueList = this.getLeagueList(this.matches_list);                        
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    this.$errorToast(error);
                }
            });
        },
        getLeagueList(arr) {
            return arr.filter((obj, index) => {
                return index === arr.findIndex(o => obj.league_name === o.league_name);
            });
        },
        clickOnSelectLeague(item) {
            if (item == 'All') {
                this.selectedLeague = [];
                this.getSportsList();
            } else {
                if (this.selectedLeague && this.selectedLeague.includes(item.league_id)) {
                    this.selectedLeague = this.selectedLeague.filter(s => s != item.league_id);
                }
                else {
                    this.selectedLeague.push(item.league_id);
                }
                this.matches_list = this.matchesArray.filter(match=>this.selectedLeague.includes(match.league_id));
            }
        },
        getCasinoGamesServiceCall() {		
            let casinoData = this.$store?.getters?.gamesData;
            this.gamesData = casinoData;
            if (this.$auth.status) {
                checkInEventMangeForSection(this.gamesData)
                this.$store.dispatch('setGamesData', this.gamesData);
            }
            
            this.sectionsList = casinoData?.sections;        
            this.homeSectionMenus = this.gamesData?.sections?.find(item => item.slug == 'casino');
            this.menuGameList = this.homeSectionMenus?.menus?.[0];
        },
        handleScroll() {
            this.scrollHeight = window.scrollY > 200;
        },
        goToGames(game){
            this.$router.push({name: 'casino-slot', params: {type: 'casino'}, query: {menuName: game.slug}});
        },
        getImgs(sport) {
            if(sport.id == 4) {
                return require('@/assets/images/cricket-img.png') //cricket
            } else if(sport.id == 1) {
                return require('@/assets/images/1.webp') //soccer
            } else if(sport.id == 2) {
                return require('@/assets/images/tennis-img.png') //tennis
            } else if(sport.id == 648) {
                return require('@/assets/images/648.webp') //kabbadi
            }
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        getSportsListService(item) {
            if(this.$route.params.head_sport) {
                this.$router.push({params: {type: '', id: '', head_sport : ''}});
            };
            this.getSportsList(item);
        },
        getSportImage(sportId) {
            const imageMap = {
                4: require("@/assets/images/sports-cricket.svg"),
                1: require("@/assets/images/sports-soccer.svg"),
                2: require("@/assets/images/sports-tennis.svg"),
                1477: require("@/assets/images/sports-rugby-league.svg"),
                6: require("@/assets/images/sports-boxing.svg"),
                5: require("@/assets/images/sports-rugby-union.svg"),
                3: require("@/assets/images/sports-golf.svg"),
                27454571: require("@/assets/images/sports-esports.svg"),
                2152880: require("@/assets/images/sports-gaelic-football.svg"),
                998917: require("@/assets/images/sports-volleyball.svg"),
                7524: require("@/assets/images/sports-ice-hockey.svg"),
                7522: require("@/assets/images/sports-basketball.svg"),
                7511: require("@/assets/images/sports-baseball.svg"),
                6423: require("@/assets/images/sports-american-football.svg"),
                6422: require("@/assets/images/sports-snooker.svg"),
                11: require("@/assets/images/sports-cycling.svg"),
                8: require("@/assets/images/sports-motor-sport.svg"),
                2378961: require("@/assets/images/sports-politics.svg"),
                468328: require("@/assets/images/sports-handball.svg"),
                61420: require("@/assets/images/sports-australian-rules.svg"),
                3503: require("@/assets/images/sports-darts.svg"),
                10: require("@/assets/images/sports-special-bets.svg"),
                26420387: require("@/assets/images/sports-mixed-martial-arts.svg"),
                4339: require("@/assets/images/sports-greyhound-racing.svg"),
                7: require("@/assets/images/sports-horse-racing.svg"),
            };
            return imageMap[sportId] || require("@/assets/images/sports-no.svg");
        },
        toggleFilter(filterKey) {
            if (this.selectedFilters.includes(filterKey)) {
                this.selectedFilters = this.selectedFilters.filter(f => f !== filterKey);
            } else {
                this.selectedFilters.push(filterKey);
            }            
        },
        playVideo(videoKey, imageKey, title) {
            const base = this.$siteSettings?.data?.user_journey;
            this.videoUrl       = this.$siteSettings?.data?.aws_url + this.$siteSettings?.data?.storage_path.user_journey_path + base[videoKey];
            this.videoThumbnail = imageKey ? this.$siteSettings?.data?.aws_url + this.$siteSettings?.data?.storage_path.user_journey_path + base[imageKey] : null;
            this.videoTitle     = title;
        },
    },
    watch: {
        '$route.params.id': function() {
            if(this.$route.params.id) {
                this.getSportsList();
            }
        }
    },
};
</script>

<style scoped>
.mobile-game-live.sports-height .game-listing-container{
    max-height: none;
}
.video-display{
  height: 160px;
  width: 100%;
}
</style>
